import { useSelector } from 'react-redux'

import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { AppState } from '../App/store'

export interface EvtState {
  eventId: string
  eventName: string
  eventCode?: string
  eventUrl?: string
  allowpaymentoffees?: boolean
  billme?: boolean
  allowattendedbytickettype?: boolean
  ccfee?: number
}

const initialState: EvtState = {
  eventId: '',
  eventName: '',
  eventCode: '',
  eventUrl: '',
  allowpaymentoffees: false,
  billme: false,
  ccfee: 0,
}

export const evtSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setEvt: (state, { payload }: PayloadAction<EvtState>) => {
      state.eventId = payload.eventId
      state.eventName = payload.eventName
      state.eventCode = (payload.eventCode ? payload.eventCode : state.eventCode)
      // state.eventStart = (payload.actual ? payload.actual : state.actual)
      // state.eventEnd = (payload.eventEnd ? payload.eventEnd : state.eventEnd)
      // state.bidStart = (payload.bidStart ? payload.bidStart : state.bidStart)
      // state.bidEnd = (payload.bidEnd ? payload.bidEnd : state.bidEnd)
      state.allowpaymentoffees = payload.allowpaymentoffees
      state.ccfee = payload.ccfee
    },
    setEvtUrl: (state, { payload }: PayloadAction<string>) => {
      state.eventUrl = payload
    },
  }
})

/** ACTION EXPORTS */
export const {
  setEvt, setEvtUrl
} = evtSlice.actions

/** REDUCER EXPORT */
export default evtSlice.reducer

/** STATE HOOK EXPORTS - hooks for components to get state */
export const useEvtState = () => useSelector((state: AppState) => state.evt)
